import { LandingPage } from '@/interfaces/user.interface'
import LpTag from '@components/lp-tag/lp-tag.component'
import React, { useCallback, useEffect, useLayoutEffect, useRef, useState } from 'react'
import './lp-list.component.scss'

const TWO_REM = 28
const WIDTH_BOX_SHORT_NUMBER = 33

interface Props {
  squidWhitelabels: LandingPage[]
  setSquidWhitelabels?: SetSquidWhitelabels
  moreWhitelabels: number
  setMoreWhitelabels?: SetMoreWhitelabels
}

interface SetSquidWhitelabels {
  (prev: React.SetStateAction<LandingPage[]>): void
}

interface SetMoreWhitelabels {
  (value: React.SetStateAction<number>): void
}

export default ({ squidWhitelabels, setSquidWhitelabels, moreWhitelabels, setMoreWhitelabels }: Props) => {
  const lplist = useRef<HTMLDivElement>(null)
  const [mySquidList, setMySquidList] = useState<LandingPage[]>([])
  const [moreMySquid, setMoreMySquid] = useState<number>(0)

  const checkChildWidthIsGreaterThanParent = useCallback((child, parent): boolean => {
    if (child?.children?.length) {
      const getWidthTotal = (): number =>
        Array.from(child.children).reduce((acc: number, cur: HTMLElement): number => acc + cur.offsetWidth, 0) as number

      return getWidthTotal() >= parent.clientWidth - TWO_REM - WIDTH_BOX_SHORT_NUMBER
    }
  }, [])

  useEffect(() => {
    setMySquidList(squidWhitelabels)
    setMoreMySquid(0)
  }, [squidWhitelabels])

  useLayoutEffect(() => {
    if (mySquidList.length > 0) {
      const container = lplist.current?.parentNode
      const listElements = lplist.current
      if (listElements) {
        if (checkChildWidthIsGreaterThanParent(listElements, container) && squidWhitelabels.length > 1) {
          squidWhitelabels.splice(squidWhitelabels.length - 1, 1)
          setMySquidList(squidWhitelabels)
          setMoreMySquid(moreMySquid + 1)
        }
      }
    }
  }, [checkChildWidthIsGreaterThanParent, squidWhitelabels, mySquidList?.length, moreMySquid])

  return (
    <div ref={lplist} className="lp-list my-4">
      {mySquidList?.map(({ _id, images: { favicon }, name }) => (
        <LpTag id={_id} name={name} icon={favicon.url} key={_id} />
      ))}
      {moreMySquid > 0 && <LpTag moreWhiteLabels={moreMySquid} />}
    </div>
  )
}
